module.exports = __webpack_public_path__ + "static/img/logoAll.21085c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoAll.png
// module id = 6rEk
// module chunks = 1